import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { navLinks, companyInfo } from '../../data/mock';
import { Button } from '../ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-zinc-900 shadow-lg' : 'bg-zinc-900/95'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/images/Logo/website_logo.png"
              alt="The House of Renovation and Design"
              className="h-12 lg:h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-bold uppercase tracking-wide transition-colors duration-200 ${
                  location.pathname === link.path 
                    ? 'text-orange-500' 
                    : 'text-zinc-300 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden lg:flex items-center gap-6">
            <a
              href={`tel:${companyInfo.phone}`}
              className="flex items-center gap-2 text-white font-bold hover:text-orange-500 transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm">{companyInfo.phone}</span>
            </a>
            <Link to="/contact">
              <Button className="bg-orange-500 hover:bg-orange-600 text-white font-black uppercase tracking-wide px-6 rounded-none">
                Get Quote
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-white hover:text-orange-500 transition-colors"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden absolute top-full left-0 right-0 bg-zinc-900 border-t border-zinc-800 transition-all duration-300 overflow-hidden ${
          isMenuOpen ? 'max-h-[400px]' : 'max-h-0'
        }`}
      >
        <nav className="flex flex-col py-2">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMenuOpen(false)}
              className={`px-6 py-4 text-sm font-bold uppercase tracking-wide border-b border-zinc-800 ${
                location.pathname === link.path ? 'text-orange-500 bg-zinc-800/50' : 'text-white'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <div className="p-4">
            <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
              <Button className="w-full bg-orange-500 hover:bg-orange-600 text-white font-black uppercase tracking-wide rounded-none">
                Get Quote
              </Button>
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;